import styled from 'styled-components'

export const Container = styled.div`
  background-image: ${({ background }) => `url(${background})`};
  background-position: center center;
  background-size: cover;
  border-radius: 8px;
  height: 190px;
  overflow: hidden;
  padding: 15px 24px;
  position: relative;

  &::before {
    background: #2e2d37;
    content: '';
    display: block;
    height: 127px;
    left: 0;
    mask-image: linear-gradient(to bottom, #2e2d37, transparent);
    position: absolute;
    right: 0;
    top: 0;
    opacity: 0.4;
  }

  a {
    &::before {
      bottom: 0;
      content: '';
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
    }
  }
`
export const Title = styled.h3`
  color: #fff;
  font-size: 24px;
  font-weight: 500;
  line-height: 36px;
  max-width: 180px;
  position: relative;
`
